import { Icon } from '../icons/Icon'
import { Button } from '../inputs/button/Button'
import Link from '../navigation/Link'

export default function HeaderTopBanner() {
  return (
    <div
      className={`
        flex h-[32px] w-full items-center justify-center border-b
        border-[rgba(255,255,255,0.1)] bg-primary-550
      `}
    >
      <div className="flex items-center justify-center gap-2">
        <p className="font-saira text-[12px] font-normal text-white">
          Híbridos con batería en garantía
        </p>
        <Link
          to={
            '/nuestros-coches?combustible=Híbrido&combustible=Híbrido enchufable&combustible=Mild Hybrid&manufacturerBatteryWarranty=true'
          }
        >
          <Button
            variant={'outlineInput'}
            className={`
              flex h-[20px] w-[88px] items-center justify-center gap-1 px-2
            `}
          >
            <p
              className={`
                whitespace-nowrap text-nowrap text-subtitle3-semibold
                font-normal leading-[0px] text-white
              `}
            >
              Ver coches
            </p>
            <Icon size="12px" color="white" name="basic/arrow-right" />
          </Button>
        </Link>
      </div>
    </div>
  )
}
